"use client"

import { useEffect, useState } from "react"
import {
  isStaleDeploymentError,
  nextShowReloadCta,
  performStaleDeploymentReload,
  staleDeploymentErrorIdentity,
} from "@/shared/lib/stale-deployment"

export type StaleDeploymentRecovery = {
  isStale: boolean
  showReloadCta: boolean
}

/**
 * On a stale-chunk / Server Action / deploy-skew error, reload once.
 * If that already happened in this tab, surface a manual reload CTA.
 * A later ordinary error clears the CTA so the boundary shows Try Again.
 */
export function useStaleDeploymentRecovery(
  error: Error
): StaleDeploymentRecovery {
  const isStale = isStaleDeploymentError(error)
  const errorIdentity = staleDeploymentErrorIdentity(error)
  const [showReloadCta, setShowReloadCta] = useState(false)

  useEffect(() => {
    if (!isStale) {
      setShowReloadCta(false)
      return
    }

    const autoReloadClaimed = performStaleDeploymentReload() !== "blocked"
    setShowReloadCta(nextShowReloadCta(isStale, autoReloadClaimed))
  }, [errorIdentity, isStale])

  return { isStale, showReloadCta }
}
